<template>
  <div class="full">
    <div class="container">
      <img src="../static/404.png" alt="">
      <div class="error">404</div>
      <van-button style="width:35%;" @click="toFresh" round type="info">刷新</van-button>
    </div>
  </div>
</template>

<script>
import {
  Button,
} from "vant";
import * as _localStorage from '@/utils/storage';
export default {
  components: {
    [Button.name]: Button,
  },
  methods: {
    toFresh() {
      if (_localStorage.getStorageSync('toPath')) {
        this.$router.push(_localStorage.getStorageSync('toPath'))
      } else {
        this.$router.replace('/search')
      }
    }
  }
};
</script>

<style lang="less" scoped>
.full {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .container {
    text-align: center;
    width: 100%;
    height: 300px;
  }
  img {
    width: 200px;
    height: 102px;
  }
  .error {
    width: 100%;
    text-align: center;
    font-size: 36px;
    height: 80px;
  }
}
</style>